module.exports = __webpack_public_path__ + "media/70.f03fd371.wav";